import { useEffect, useState } from "react";
import { Landmark, HeartPulse, Baby, Briefcase, Home, Newspaper } from "lucide-react";

export const NAV_GROUPS = [
  {
    id: "okonomi",
    label: "Kommunen og økonomien",
    icon: Landmark,
    items: [
      { id: "nokkeltall", label: "Nøkkeltal" },
      { id: "drift", label: "Drift og gjeld" },
      { id: "inntektskilder", label: "Inntektskjelder" },
      { id: "driftsutgifter", label: "Driftsutgifter" },
      { id: "investeringer", label: "Investeringar" },
      { id: "arbeidskapital", label: "Arbeidskapital" },
      { id: "disposisjonsfond", label: "Disposisjonsfond" },
      { id: "fond", label: "Fondsoversikt" },
      { id: "finanskostnader", label: "Finanskostnader" },
      { id: "eiendom", label: "Eigedomsmasse" },
      { id: "varsel", label: "Historiske varsel" },
      { id: "rangering", label: "Rangering" },
      { id: "detaljert", label: "Detaljerte tal" },
    ],
  },
  {
    id: "helse",
    label: "Helse og omsorg",
    icon: HeartPulse,
    items: [
      { id: "fastlege", label: "Fastlegedekning" },
      { id: "tjenester", label: "Tenester til barn og eldre" },
      { id: "korttid", label: "Korttidsopphald" },
      { id: "framskriving", label: "Framskriving" },
    ],
  },
  {
    id: "barnunge",
    label: "Barn og unge",
    icon: Baby,
    items: [
      { id: "alder", label: "Alder, barn og eldre" },
      { id: "ulikskap", label: "Barnefattigdom og ulikskap" },
    ],
  },
  {
    id: "arbeidsliv",
    label: "Folk og arbeidsliv",
    icon: Briefcase,
    items: [
      { id: "befolkning", label: "Befolkning og inntekt" },
      { id: "arbeid", label: "Arbeid og ytingar" },
      { id: "pendling", label: "Pendling og næringar" },
    ],
  },
  {
    id: "bustad",
    label: "Bustad og hushaldsøkonomi",
    icon: Home,
    items: [
      { id: "husholdning", label: "Hushaldsøkonomi" },
      { id: "livsopphald", label: "Livsopphald" },
      { id: "levekostnad", label: "Levekostnader" },
      { id: "bolig", label: "Bustad og bokostnader" },
      { id: "boligpriser", label: "Bustadprisar" },
      { id: "leie", label: "Leige" },
      { id: "gebyrer", label: "Gebyr" },
    ],
  },
  { id: "artikler", label: "Artiklar og lenkjer", icon: Newspaper, items: [] },
];

const hoppTil = (e, id) => {
  const el = document.getElementById(id);
  if (!el) return;
  e.preventDefault();
  const nav = document.querySelector('[data-testid="section-nav"]');
  const topp = 64 + (nav?.offsetHeight || 0) + 12;
  window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - topp, behavior: "smooth" });
};

const SectionNav = () => {
  const [active, setActive] = useState("okonomi");

  useEffect(() => {
    const ids = NAV_GROUPS.map((g) => g.id);
    const onScroll = () => {
      const nav = document.querySelector('[data-testid="section-nav"]');
      const offset = 64 + (nav?.offsetHeight || 0) + 24;
      let current = ids[0];
      ids.forEach((id) => {
        const el = document.getElementById(id);
        if (el && el.getBoundingClientRect().top - offset <= 0) current = id;
      });
      setActive(current);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav className="sticky top-[64px] z-30 -mx-4 sm:-mx-6 lg:-mx-8 px-4 sm:px-6 lg:px-8 bg-[#F6F8FB]/95 backdrop-blur border-b border-[#E6E9F0] mb-8" data-testid="section-nav" aria-label="Sidenavigasjon">
      <div className="flex flex-wrap items-center gap-x-6 gap-y-1 py-2">
        {NAV_GROUPS.map((g) => (
          <div key={g.id} className="flex items-center gap-2 flex-wrap py-1">
            <a
              href={`#${g.id}`}
              onClick={(e) => hoppTil(e, g.id)}
              className={`inline-flex items-center gap-1.5 text-sm font-medium px-2.5 py-1 rounded-full transition-colors ${active === g.id ? "bg-[#103766] text-white" : "text-[#1F2A36] hover:bg-white"}`}
              data-testid={`nav-${g.id}`}
            >
              <g.icon className="w-3.5 h-3.5" /> {g.label}
            </a>
            {g.items.length > 0 && (
              <span className="hidden lg:flex items-center gap-1 text-xs text-[#4B647F]">
                {g.items.map((it, i) => (
                  <span key={it.id} className="flex items-center gap-1">
                    {i > 0 && <span className="text-[#C9D2DE]">·</span>}
                    <a
                      href={`#${it.id}`}
                      onClick={(e) => hoppTil(e, it.id)}
                      className="hover:text-[#103766] hover:underline"
                      data-testid={`nav-${it.id}`}
                    >
                      {it.label}
                    </a>
                  </span>
                ))}
              </span>
            )}
          </div>
        ))}
      </div>
    </nav>
  );
};

export default SectionNav;
